import { uncapitalize } from '@attain-apps/string-utils'

import * as core from '../../../../../../core'
import * as common from '../../../../../common'

import * as mtdcCategory from './mtdc-category'

// NOTE: everything below is designed to simulate a normal folder/module
// structure for exporting resources from separate files. This just simply
// generates those resources based on the known enum entries

const enumId = core.dms.models.Enum.Id.from({
  partialId: mtdcCategory.RESOURCE.payload.partialId,
})

const enumEntryResourceNameLookup = {} as Record<common.MtdcCategory, string>
for (const enumEntryName in common.MtdcCategory) {
  const potentialEnum =
    common.MtdcCategory[enumEntryName as keyof typeof common.MtdcCategory]
  if (common.MtdcCategory.isMtdcCategory(potentialEnum)) {
    enumEntryResourceNameLookup[potentialEnum] = uncapitalize(enumEntryName)
  }
}

export const entries = common.MtdcCategory.ALL.reduce(
  (prev, _mtdcCategory) =>
    Object.assign(prev, {
      [enumEntryResourceNameLookup[_mtdcCategory]]: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        RESOURCE: {
          payload: {
            ...common.MtdcCategory.getEntry(_mtdcCategory),
            enumId,
          },
          type: core.quiver.Resource.Type.DmsEnumEntry,
        } as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>,
      },
    }),
  {} as {
    [K in keyof typeof common.MtdcCategory as (typeof common.MtdcCategory)[K] extends common.MtdcCategory
      ? Uncapitalize<K>
      : never]: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RESOURCE: core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
    }
  },
)
